import RoBosunPainterImg from "../images/painterPage/roboPainter.jpg";
import PainterGif from "../images/painterPage/painter.gif";

const highlights = [
    {
        title: ["High-Speed Painting", "Consistent Paint Quality"],
        description: ["Completes painting tasks faster than human workers", "Delivers uniform and high-quality paint application"],
        image: PainterGif,
        imageAlt: "RoBosun Painter",
        backgroundColor: "#c5c5c5",
        imagePlacement: "right"
    },
    {
        title: ["Cost Savings", "Enhanced Safety"],
        description: ["Reduces expenses by eliminating the need for scaffolding or gondola setups", "Minimizes human exposure to hazardous conditions"],
        image: RoBosunPainterImg,
        imageAlt: "RoBosun Painter",
        backgroundColor: "#ffffff",
        imagePlacement: "left"
    }
];

export default highlights;